import {FETCH_PRESENTATION_REQUEST, FILTER_PRESENTATION_GROUPS} from './constants'

export function fetchPresentation() {
  return {type: FETCH_PRESENTATION_REQUEST}
}

export function filterGroups(groups) {
  return {type: FILTER_PRESENTATION_GROUPS, groups}
}



// WEBPACK FOOTER //
// ./src/actions/presentation.js